import { createFileRoute } from '@tanstack/react-router';

/**
 * The parent of everything under `/properties/<ref>` — and deliberately nothing else.
 *
 * It has NO component, which is the entire point. Under flat file routing
 * `properties.$ref.edit.tsx` nests beneath a `/properties/$ref` route whether or not one is
 * written, so this file exists to say what that route is: a passthrough. A route with no
 * component renders `<Outlet />` by default, so each child renders alone.
 *
 * The record itself lives in `properties.$ref.index.tsx`. Leaving it here would make it the edit
 * page's parent, and a parent without an outlet swallows its children — the same failure
 * `/people/$ref` was split to fix, where Edit matched correctly and then had the read-only
 * record painted over the top of it.
 *
 * No `beforeLoad` here either. Ref normalisation belongs to each child, because they redirect to
 * different paths — a parent that sent every ref to `/properties/$ref` would bounce anyone
 * trying to edit one straight back out of the form.
 *
 * `routing.test.ts` pins the rule for every route: no route may have both children and a
 * component.
 */
export const Route = createFileRoute('/properties/$ref')({});
